"use client";

import { useEffect, useState } from "react";

export type LiveNumbers = {
  freeNumbers: any[];
  privateNumbers: any[];
};

/**
 * Fetches the current number inventory for a country ("all" = every
 * country's private numbers) to overlay onto the statically built lists.
 * Returns null until loaded (or on failure), so callers fall back to the
 * static data.
 */
export function useLiveNumbers(countryCode?: string | null): LiveNumbers | null {
  const [live, setLive] = useState<LiveNumbers | null>(null);

  useEffect(() => {
    setLive(null);
    if (!countryCode) return;
    let cancelled = false;
    const url =
      countryCode === "all"
        ? "/api/numbers/available"
        : `/api/numbers/available?country=${encodeURIComponent(countryCode)}`;
    fetch(url)
      .then((res) => (res.ok ? res.json() : null))
      .then((json) => {
        if (!cancelled && json && !json.error) setLive(json);
      })
      .catch(() => {
        // keep static data on failure
      });
    return () => {
      cancelled = true;
    };
  }, [countryCode]);

  return live;
}
